module.exports = __webpack_public_path__ + "img/cog-red.97b87606.svg";